/*@flow*/
import * as I from 'immutable';
import type { StateT } from './types';
import panels from './panels';

const initState = {
  // Folio map
  decks: I.Map(),
  schema: I.Map(),
  loading: false,
  // Layers (deprecated)
  loadedLayers: I.Map(),
  activeLayers: I.Map(),
  // Panels
  activePanel: null, // 'LOCATION_DETAILS' | 'FILTERS' | 'LAYERS' | 'ANALYSIS' | 'PUBLIC_DATA' | 'TOOLS'
  focusedLatlon: null, // { lat: number, lon: number }
  focusedResourceId: null, // e.g. 160
  focusedResourceType: '', // e.g. 'Listing'
  focusedResourceColor: '', // e.g. 'red'
  HISTORY_SHOT: null, // { filters: {}, layers: {} }
  // Location panel
  locHeaderToolsOpen: true,
  locPubSearchQuery: '',
  locPubSearchTag: '',
  locActiveId: null,
  locActiveName: '',
  locActiveModalName: '', // 'NEW_RECORD' | 'EDIT_RECORD' | 'NEW_DATA_PANEL' | 'EDIT_DATA_PANEL' | 'DUP_DATA_PANEL'
  searchAddressInput: '',
  searchKeywordInput: '',
  // Layers panel
  layersLoaded: [],
  layersLoadedQueryMap: I.Map(),
  layersActiveLayers: I.Set(),
  layersActiveLayerGroup: null,
  // List view panel
  listViewOrder: 'name',
  listViewOrderDir: 'asc',
  // Filters panel
  filtersSections: [],
  filtersSectionsOriginal: [],
  // Tools panel
  toolsShowLabels: false,
  toolsShowShapes: false,
  toolsMarkerColorsOpen: false,
  toolsBasemapsOpen: false,
  showImagesInListView: true,

  panels: Object.keys(panels).filter((v) => v !== 'LIST_VIEW'),
};

// Layers
//
// {
//   uuid: 1,
//   type: 'cdb',
//   name: 'Test',
//   collection: 'Property',
//   query: { deck: { 'Test Layer': 'on' } },
// },
// { uuid: 2, type: 'cdb', name: 'Test2', collection: 'Property' },
// {
//   uuid: 3,
//   type: 'cdb',
//   name: 'Test3 Test3 Test3 Test3 Test3 Test3 Test3 Test3',
//   collection: 'Demographics',
// },

const fn: I.RecordFactory<StateT> = I.Record(initState, 'State');

export default fn;
